var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "pause_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#pause_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M14.75 19a1.44 1.44 0 0 1-1.057-.445 1.452 1.452 0 0 1-.443-1.061V6.506c0-.41.148-.764.443-1.06A1.44 1.44 0 0 1 14.75 5H17c.409 0 .761.148 1.057.445.295.297.443.65.443 1.061v10.988c0 .41-.148.764-.443 1.06A1.44 1.44 0 0 1 17 19h-2.25ZM7 19a1.44 1.44 0 0 1-1.057-.445 1.451 1.451 0 0 1-.443-1.061V6.506c0-.41.148-.764.443-1.06A1.44 1.44 0 0 1 7 5h2.25c.409 0 .761.148 1.057.445.295.297.443.65.443 1.061v10.988c0 .41-.148.764-.443 1.06A1.44 1.44 0 0 1 9.25 19H7Zm7.75-1.506H17V6.506h-2.25v10.988Zm-7.75 0h2.25V6.506H7v10.988Z",
    fill: "currentColor"
  }))));
};
export default SvgPause;